import assetsExplorerModule from "../assetsExplorerModule.js";

const assetsExplorerComponent = {
    templateUrl: "assets-explorer",
    bindings: {
        "userId": "<",
        "assetsPager": "<",
        "assets": "<",
        "currentData": "<",
        "pageType": "<",
        "showCreatorName": "<"
    },
    controller: "assetsExplorerController"
};

assetsExplorerModule.component("assetsExplorer", assetsExplorerComponent);
export default assetsExplorerComponent;